import React, { useState } from 'react';
import "./SortInput.css"
import { ChevronUp, ChevronDown } from 'lucide-react';
import { useTranslation } from '../../contexts/TranslationContext'; 

const SortInput = ({sortOrder, setSortOrder}) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    
    
    const toggleSortOrder = () => {
        setSortOrder(sortOrder === 'Oldest to Newest' ? 'Newest to Oldest' : 'Oldest to Newest');
    };

    const handleToggleDropdown = () => {
        setIsOpen(!isOpen);
        toggleSortOrder();
    };

    return (
        <div className="sort-input-container" onClick={handleToggleDropdown}>
            {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            <span className="sort-input-text">
                <strong>{t("Sort")}:</strong> {sortOrder==="Oldest to Newest"? t("OldestToNewest"):t("NewestToOldest")}
            </span>
        </div>
    );
};

export default SortInput;
